<template>
    <div id="app">
        <channelList v-if="buttonsVisible"></channelList>
        <dayList></dayList>
        <channelBar></channelBar>
        <progList v-if="isReady"></progList>
    </div>
</template>


<script>
import dayList from '@/components/day-list.vue'
import progList from '@/components/prog-list.vue'
import channelList from '@/components/channel-list.vue'
import channelBar from '@/components/channel-bar.vue'

import lib from '@/lib'

export default {
    name: 'app',
    data() {
        return {
        name: 1,
        buttonsVisible: true,
        standalone: true
        }
    },
    components: {
        dayList,
        progList,
        channelList,
        channelBar
    },
    computed: {
        isReady() {
            return this.$store.state.ready
        },
        urlQuery() {
            return window.location
        }
    },
    methods: {
        genDayList: lib.genDayList
    },
    mounted() {

        if (window.sched_config) {
            let sched_config  = window.sched_config

            this.$store.commit('setChannel', sched_config.channel)
            this.buttonsVisible = sched_config.buttons
        }

            let urlParams = parseUrl(window.location.search)

            if (urlParams.channel) {
                this.$store.commit('setChannel', urlParams.channel)
            }

            if (urlParams.buttons === '0') {

                this.buttonsVisible = false

            }

            if (urlParams.standalone === '1' || this.standalone) {
                let body = document.getElementsByTagName('body')[0]
                // body.style.overflow = "hidden"
                body.style.margin = 0;
            }

            setTimeout(function() {
                var p = document.getElementById('program-list')
                p.style.height = (window.innerHeight - p.offsetTop) + 'px'
            },300)


            // window.onresize = function() {
            //     let a = document.getElementById('app')
            //     a.style.height = (window.innerHeight - 84) + 'px'
            // }


function parseUrl(url) {
    let query = url.slice(1,-1)
    if (query) {
        let params = query.split('&').map(n => {
                return n.split('=')
            })
    let Obj = {}
    params.forEach(n => {
        Obj[n[0]] = n[1]
    })
    return Obj
    }
    else return {}
}







        this.$store.commit('selectDay', new Date().getDay())
        this.genDayList()
        lib.fetchSchedData(this.$store.state.channel, this.$store.state.days[(this.$store.state.selectedDay) + (this.$store.state.week * 7)].dateA)
    }
}
</script>

<style lang="sass">
@import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700,900')
@import url('https://fonts.googleapis.com/css?family=Barlow+Semi+Condensed:400,500,700')
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css')
@import "sass/app.sass"
</style>




// WEBPACK FOOTER //
// src/App.vue